import { render, staticRenderFns } from "./comments-list.vue?vue&type=template&id=3349d2ff&scoped=true&"
import script from "./comments-list.vue?vue&type=script&lang=js&"
export * from "./comments-list.vue?vue&type=script&lang=js&"
import style0 from "./comments-list.vue?vue&type=style&index=0&id=3349d2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349d2ff",
  null
  
)

export default component.exports